<template>
  <div v-if="viewport" class="relation">
    <banner :nav-index="6">
      <template slot="banner">
        <div class="banner">
          <div class="center" :style="{'will-change': 'transform',transform: `translate3d(0,${transLateY}px,0)`}">
            <div class="text">
              <h2 class="distance">Join Us<br/> Create The Future</h2>
              <div class="line"></div>
              <div class="txt interval">
                To expand and recreating human sensorium with novel interactive technologies between human and machines;
                to achieve human digital and machine immortality through AI-based wearable robotic technologies.
              </div>
              <div class="txt">
                Our mission is to provide high-quality, personalized services for people’s health, interactions, and
                happiness via intelligent wearable robotics.
              </div>
              <div class="btn">Reshape The Future.</div>
            </div>
          </div>
        </div>
      </template>
    </banner>
    <div style="position: relative;z-index: 2;background-color: #fff">
      <div class="collaborate">
        <div class="center">
          <div class="postbox">
            <h2>Business Cooperation</h2>
            <p>bp@maschinerobot.com</p>
            <h1>Maschine Robot</h1>
            <h2>Join Maschine Robot</h2>
            <p>hr@maschinerobot.com</p>
          </div>
        </div>
      </div>
      <relation></relation>
    </div>
  </div>
  <div v-else class="phone-wrap">
    <div class="background">
      <div class="nav">
        <div class="logo">
          <img src="@/assets/phone/phone-logo.png">
        </div>
        <div @click="onList" class="fork">
          <span class="iconfont icon-liebiaoshitucaidan"></span>
        </div>
      </div>
      <div class="title">
        <h2>Join Us</h2>
        <h2>Create The Future</h2>
        <div class="btn">Reshape The Future.</div>
      </div>

      <div v-show="list" class="list">
        <phoneNav @onHide="onHide"></phoneNav>
      </div>
    </div>
    <div class="txt">
      <p>
        To expand and recreating human sensorium with novel interactive technologies between human and machines; to
        achieve human digital and machine immortality through AI-based wearable robotic technologies.

      </p>
      <p class="top">
        Our mission is to provide high-quality, personalized services for people’s health, interactions, and happiness
        via intelligent wearable robotics.
      </p>
    </div>
    <div class="content">
      <h2>Business Cooperation</h2>
      <p>bp@maschinerobot.com</p>
      <h1>Maschine Robot</h1>
      <h2>Join Maschine Robot</h2>
      <p>hr@maschinerobot.com</p>
    </div>
    <phoneFooter></phoneFooter>
  </div>
</template>

<script>
import banner from '@/components/banner'
import relation from '@/components/footer'
import phoneNav from '@/components/phoneNav/index'
import phoneFooter from "@/components/phoneFooter";

export default {
  name: "relation.vue",

  components: {
    phoneNav,
    banner,
    relation,
    phoneFooter,
  },
  mounted() {
    window.addEventListener('scroll', this.handleScroll) // 监听页面滚动
    this.screenWidth = document.body.clientWidth
    if (document.documentElement.clientWidth < 1280) {
      this.viewport = false
    }
    window.onresize = () => {
      //屏幕尺寸变化
      return (() => {
        this.screenWidth = document.body.clientWidth

      })()
    }
  },
  data() {
    return {
      toTop: 0,
      transLateY: 0,
      viewport: true,
      screenWidth: null,
      list: false,
    }

  },
  destroyed() {
    window.removeEventListener('scroll', this.handleScroll)
  },
  watch: {
    screenWidth: function (n, o) {
      if (n <= 1024) {
        this.viewport = false
      } else {
        this.viewport = true
      }
    }
  },
  methods: {

    onList() {
      setTimeout(() => {
        this.list = true
      }, 200)

    },

    onHide() {
      setTimeout(() => {
        this.list = false
      }, 200)

    },


    handleScroll() {
      let scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
      if (scrollTop < 900) {
        if (this.toTop <= scrollTop) {
          this.transLateY = scrollTop / 10
        } else {
          this.transLateY = -scrollTop / 10
        }
      }
      this.toTop = scrollTop
    }
  }
}
</script>

<style scoped>

.center {
  width: 1200px;
  margin: 0 auto;
}

.center .text {
  padding-top: 100px;
}


.center .text h1 img {
  height: 56px;
}

.center .text .distance {
  margin-bottom: 24px;
}

.center .text h2 {
  font-weight: 700;
  font-size: 54px;
  line-height: 80px;
  color: #FFFFFF;
}

.center .text .line {
  margin-top: 40px;
  height: 6px;
  width: 50px;
  background-color: #FFFFFF;
}

.center .text .txt {
  color: #FFFFFF;
  font-size: 24px;
  line-height: 36px;
}

.center .text .interval {
  margin-top: 50px;
  padding-bottom: 10px;
}

.center .text .btn {
  width: 400px;
  height: 71px;
  font-weight: 700;
  font-size: 34px;
  line-height: 71px;
  color: #FFFFFF;
  border-top: 1px solid #fff;
  border-bottom: 1px solid #fff;
  margin-top: 60px;
}

.collaborate {
  height: 900px;
}

.collaborate .postbox {
  padding-top: 150px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.collaborate .postbox h2 {
  margin-bottom: 40px;
  font-weight: 700;
  font-size: 54px;
  line-height: 81px;
}

.collaborate .postbox p {
  font-size: 24px;
  line-height: 42px;
}

.collaborate .postbox h1 {
  margin: 64px 0;
  font-size: 86px;
  color: #f2f4f9;
}

.nav {
  display: flex;
  justify-content: space-between;
  padding: 1.14rem 0.6rem 0;
}

.nav .logo {
  display: flex;
  align-items: center;
  height: 0.43rem;
}

.nav .logo img {
  height: 0.35rem;
}

.nav .fork {
  color: #FFFFFF;
  line-height: 0.43rem;
  height: 0.43rem;
}

.nav .fork .iconfont {
  font-size: 0.36rem;
}

.list {
  width: 100%;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 9;
}

.background {
  background-image: url("../../assets/phone/join.jpg");
  background-repeat: no-repeat;
  background-size: cover;
}

.background .title {
  padding: 1.07rem 0 0.9rem 0.7rem;
}

.background .title h2 {
  font-style: normal;
  font-weight: 700;
  font-size: 0.46rem;
  line-height: 0.61rem;
  color: #FFFFFF;
}

.background .title .btn {
  width: 3.8rem;
  height: 0.71rem;
  font-weight: 700;
  font-size: 0.34rem;
  line-height: 0.71rem;
  color: #FFFFFF;
  border-top: 0.01rem solid #fff;
  border-bottom: 0.01rem solid #fff;
  margin-top: 0.6rem;
}

.content {
  padding: 0.7rem 0;
  text-align: center;
}

.phone-wrap .txt {
  padding: 0.6rem 0.6rem 0.5rem 0.6rem;
}

.phone-wrap .txt p {
  font-size: 0.24rem;
  line-height: 0.4rem;
}

.phone-wrap .txt .top {
  margin-top: 0.2rem;
}

.content h2 {
  padding-bottom: 0.3rem;
  font-style: normal;
  font-weight: 600;
  font-size: 0.34rem;
  line-height: 0.45rem;
}

.content p {
  font-style: normal;
  font-weight: 400;
  font-size: 0.26rem;
  line-height: 0.38rem;
  color: #111111;
}

.content h1 {
  margin-top: 0.5rem;
  padding-bottom: 0.5rem;
  color: #f2f4f9;
  font-size: 0.52rem;
}

.content .pic img {
  height: 0.46rem;
}
</style>
